import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReduxModal from 'Common/Components/ReduxModal';
import { MODAL_AGENT_CREATE, MODAL_AGENT_TOKEN } from 'store/modals/modals';
import { closeModal, openModal } from 'store/modals/actions';
import TokenButton from './components/TokenButton';
import { Wrapper, RightWrapper } from './styled';
import Token from './components/TokenButton/components/Token';
import CreateButton from './components/CreateButton';
import CreateAgentMenu from '../CreateNewAgent';
import { RUN_STATUS_LOG } from '../Tabs/constants';
import RunStatusLog from './components/RunStatusLog';
import ConfigureButton from './components/ConfigureButton';
import DeleteButton from './components/DeleteButton';
import DeletionModal from './components/DeletionModal';
import { removeAgent, resetWizard, setPageCloudAgents, setPageUserAgents } from 'store/Agents/actions';
import Pagination from 'Common/Components/Pagination';
import { selectPage, selectRowsPerPageGrid, selectRowsPerPageList, selectShowGridView } from 'store/Filters/selectors';
import { selectAgentCount, selectCloudAgentCount } from 'store/Agents/selectors';

const ActionBar = ({ selectedTab, showCloudAgents }) => {
  const dispatch = useDispatch();

  const [agentToDelete, setAgentToDelete] = useState(null);
  const entity = showCloudAgents ? 'cloudAgents' : 'userAgents';
  const showGridView = useSelector((state) => selectShowGridView(entity, state));
  const page = useSelector((state) => selectPage(entity, state));
  const rowsList = useSelector((state) => selectRowsPerPageList(entity, state));
  const rowsGrid = useSelector((state) => selectRowsPerPageGrid(entity, state));
  const rowsPerPage = showGridView ? rowsGrid : rowsList;
  const userAgentsCount = useSelector(selectAgentCount);
  const cloudAgentsCound = useSelector(selectCloudAgentCount);
  const count = entity === 'cloudAgents' ? cloudAgentsCound : userAgentsCount;

  const markToDelete = (agent) => setAgentToDelete(agent);

  const cancelDeletion = () => setAgentToDelete(null);

  const performDelete = () => {
    setAgentToDelete(null);
    dispatch(removeAgent(agentToDelete));
  };

  const setPage = (page) => {
    if (showCloudAgents) dispatch(setPageCloudAgents(page));
    else dispatch(setPageUserAgents(page));
  };

  const onPrev = () => setPage(page - 1);

  const onNext = () => setPage(page + 1);

  const onCloseCreate = () => {
    dispatch(closeModal(MODAL_AGENT_CREATE));
    dispatch(resetWizard());
  };

  if (selectedTab === RUN_STATUS_LOG) return <RunStatusLog />;
  return (
    <Wrapper>
      {
        !showCloudAgents &&
        <>
          <CreateButton />
          <TokenButton onClick={ () => dispatch(openModal(MODAL_AGENT_TOKEN)) } />
        </>
      }
      <ConfigureButton />
      { !showCloudAgents && <DeleteButton markToDelete={ markToDelete } /> }
      <RightWrapper>
        <Pagination offset={ page } limit={ rowsPerPage } total={ count } onPrev={ onPrev } onNext={ onNext } />
      </RightWrapper>
      <ReduxModal id={ MODAL_AGENT_TOKEN }>
        <Token />
      </ReduxModal>
      <ReduxModal id={ MODAL_AGENT_CREATE }>
        <CreateAgentMenu onClose={ onCloseCreate } />
      </ReduxModal>
      <DeletionModal agentToDelete={ agentToDelete } onAccept={ performDelete } onClose={ cancelDeletion } />
    </Wrapper>
  );
};
export default ActionBar;
